import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10f34c81"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "leaveGroup",
  tabindex: "-1",
  "aria-labelledby": "leaveGroup",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "leaveGroup"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "justify-content-center mt-4 mx-3 text-name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "mx-3" }
const _hoisted_12 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_13 = {
  class: "modal fade",
  id: "leaveGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "leaveGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "modal-dialog" }
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "leaveGroupSuccess"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_19 = { class: "text-center mt-4" }
const _hoisted_20 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRoute, useRouter } from 'vue-router'
import groupsService from '@/services/groups.service'
import { ref } from 'vue'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object,
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()
const router = useRouter()
const leaveFailed = ref<boolean>(false)



const LeaveGroup = async (): void => {
  try {
    const param = { user_type: props.data?.user_type }
    const response: any = await groupsService.leaveGroupApi(route?.params?.group_id, props.data?.user_id, param)
    if (response?.status === 200) {
      leaveFailed.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.EXIT_GROUP, props.data?.user_no)
      // 2022/09/26 CW-Phuong Fix for UAT Phase2#4474: SO65 (Ph2-R20220930)
      store.dispatch(GROUPS_STORE.ACTIONS.SET_DETAIL_GROUPS, { group_id: route?.params?.group_id, prevent_loading: false })
    } else if (response?.response?.status === 404) {
      router.push('/404')
    } else {
      leaveFailed.value = true
    }
  } catch (error) {
    console.log(error)
    leaveFailed.value = true
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('leaveGroupConfirm1')), 1),
            _hoisted_6
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              (__props.data?.user_type === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.data.display_name), 1))
                : _createCommentVNode("", true),
              (__props.data?.user_type === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.data.display_name), 1))
                : _createCommentVNode("", true),
              (__props.data?.user_type === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(__props.data.operating_name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_unref(translate)('SN70textLeave1')), 1)
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(translate)('SN70textLeave2')), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                class: "me-2",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('SN71leaveGroups'),
                dataBsToggle: 'modal',
                type: 'secondary',
                dataBsTarget: '#leaveGroupSuccess',
                onClick: LeaveGroup,
                className: 'fw-bold'
              }, null, 8, ["title"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h5", _hoisted_17, _toDisplayString(_unref(translate)('leaveGroupConfirm1')), 1),
            _hoisted_18
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(leaveFailed.value ? _unref(translate)('errorLeaveGroup') : _unref(translate)('SN72leaveSuccess')), 1),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: 'secondary',
                dataBsToggle: 'modal',
                className: 'fw-bold'
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})